import PropTypes from 'prop-types'
import { useEffect, useState } from 'react'
import { Modal } from 'components/dialog/Modals'
import { ConfirmModal } from 'components/dialog/ModalTemplate'
import Table from 'components/table/Table'
import CheckBox from 'components/form/CheckBox'
import { useSelector } from 'react-redux'
import {
  checkAdult,
  checkLoanInsurance,
  checkMedical,
} from 'features/creative/creativeUtil'

const AssetAddModal = ({ on, handleClose, onClickConfirm }) => {
  const { activeAssets, channel } = useSelector(
    state => state.creative.buildCreative
  )
  const [checkedAssets, setCheckedAssets] = useState({ ...activeAssets })
  const isLoanInsurance = checkLoanInsurance(channel)
  const isAdult = checkAdult(channel)
  const isMedical = checkMedical(channel)

  useEffect(() => {
    if (!isLoanInsurance && checkedAssets.calculate) {
      setCheckedAssets({
        ...checkedAssets,
        calculate: false,
      })
    }
  }, [isLoanInsurance, setCheckedAssets, checkedAssets])

  useEffect(() => {
    setCheckedAssets({ ...activeAssets })
  }, [activeAssets])

  const onCheck = (id, checked) => {
    setCheckedAssets({
      ...checkedAssets,
      [id]: checked,
    })
  }

  return (
    <Modal className="material_layer" on={on}>
      <ConfirmModal
        title="확장소재 추가"
        handleClose={handleClose}
        onConfirm={() => onClickConfirm(checkedAssets)}
        confirmText="추가">
        <form action="#">
          <fieldset>
            <legend className="screen_out">확장소재 추가 선택 폼</legend>
            <Table className="tbl_layer" caption="확장소재 선택 표">
              <colgroup>
                <col width="115px" />
                <col />
              </colgroup>
              <Table.Body>
                {!isAdult && !isMedical && (
                  <Table.Row>
                    <th scope="row">이미지형</th>
                    <td>
                      <div className="inner_cell">
                        <CheckBox
                          label={
                            <>
                              썸네일
                              <span className="ico_comm ico_recomm">추천</span>
                            </>
                          }
                          defaultChecked={activeAssets.thumbnail}
                          onCheckedChange={v => onCheck('thumbnail', v)}
                        />
                        {(channel?.bizChannelCategory.id - 0 < 206 ||
                          channel?.bizChannelCategory.id - 0 > 225) &&
                          ![457, 556, 558, 559, 560].includes(
                            channel?.bizChannelCategory.id - 0
                          ) && (
                            <CheckBox
                              label={
                                <>
                                  멀티썸네일
                                  <span className="ico_comm ico_recomm">
                                    추천
                                  </span>
                                </>
                              }
                              defaultChecked={activeAssets.multiThumbnail}
                              onCheckedChange={v =>
                                onCheck('multiThumbnail', v)
                              }
                              className={`box_checkinp inp_wd1`}
                            />
                          )}
                      </div>
                    </td>
                  </Table.Row>
                )}
                <Table.Row>
                  <th scope="row">텍스트형</th>
                  <td>
                    <div className="inner_cell">
                      {!isMedical && (
                        <CheckBox
                          label="추가제목"
                          defaultChecked={activeAssets.additionalTitle}
                          onCheckedChange={v => onCheck('additionalTitle', v)}
                        />
                      )}
                      <CheckBox
                        label="부가링크"
                        defaultChecked={activeAssets.additionalLink}
                        onCheckedChange={v => onCheck('additionalLink', v)}
                      />
                      {!isMedical && (
                        <CheckBox
                          label="말머리"
                          defaultChecked={activeAssets.subject}
                          onCheckedChange={v => onCheck('subject', v)}
                        />
                      )}
                      {!isMedical && (
                        <CheckBox
                          label="가격테이블"
                          defaultChecked={activeAssets.priceTable}
                          onCheckedChange={v => onCheck('priceTable', v)}
                        />
                      )}
                    </div>
                  </td>
                </Table.Row>
                <Table.Row>
                  <th scope="row">버튼형</th>
                  <td>
                    <div className="inner_cell">
                      {isLoanInsurance && (
                        <CheckBox
                          label="계산하기"
                          defaultChecked={activeAssets.calculate}
                          onCheckedChange={v => onCheck('calculate', v)}
                        />
                      )}
                      <CheckBox
                        label="전화번호"
                        defaultChecked={activeAssets.phoneNumber}
                        onCheckedChange={v => onCheck('phoneNumber', v)}
                      />
                    </div>
                  </td>
                </Table.Row>
                <Table.Row>
                  <th scope="row">연동형</th>
                  <td>
                    <div className="inner_cell">
                      <CheckBox
                        label="톡채널"
                        defaultChecked={activeAssets.talkChannel}
                        onCheckedChange={v => onCheck('talkChannel', v)}
                      />
                    </div>
                  </td>
                </Table.Row>
              </Table.Body>
            </Table>
          </fieldset>
        </form>
      </ConfirmModal>
    </Modal>
  )
}

export default AssetAddModal

AssetAddModal.propTypes = {
  handleClose: PropTypes.func.isRequired,
  on: PropTypes.bool.isRequired,
  onClickConfirm: PropTypes.func.isRequired,
}
